import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';

const FIELD_PATH = {
  DISPLAY_NAME: '/display_name',
  DESCRIPTION: '/description',
} as const;

const getChangeType = (oldValueExists: string, newValueExists: string) => {
  if (oldValueExists && newValueExists) return 'Updated';
  if (oldValueExists) return 'Deleted';
  return 'Added';
};

export const SEGMENT_STRING_CHANGE_EXTENSION = createFlagUpdatesChangeExtension(
  {
    id: 'segment-string-change',
    priority: 1,
    predicate: ({ change }) =>
      change.fieldType === 'string' &&
      (change.fieldPath === FIELD_PATH.DISPLAY_NAME ||
        change.fieldPath === FIELD_PATH.DESCRIPTION),
    title: change => {
      const changeType = getChangeType(change.oldValue, change.newValue);

      if (change.fieldPath === FIELD_PATH.DISPLAY_NAME)
        return `${changeType} name`;
      if (change.fieldPath === FIELD_PATH.DESCRIPTION)
        return `${changeType} description`;
      return change.description ?? `${changeType} field`;
    },
    render: ({ change }) => (
      <DeltaText
        oldText={change.oldValue ?? ''}
        newText={change.newValue ?? ''}
        disableDiff
      />
    ),
  },
);
